function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 6H1a1 1 0 010-2h7a.999.999 0 110 2zm0-4H1a1 1 0 010-2h7a1 1 0 010 2zM1 8h7a1 1 0 010 2H1a1 1 0 010-2z"
});

var SvgList = function SvgList(props) {
  return React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5IiBoZWlnaHQ9IjEwIiB2aWV3Qm94PSIwIDAgOSAxMCI+CiAgICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTggNkgxYTEgMSAwIDAgMSAwLTJoN2EuOTk5Ljk5OSAwIDEgMSAwIDJ6bTAtNEgxYTEgMSAwIDAgMSAwLTJoN2ExIDEgMCAwIDEgMCAyek0xIDhoN2ExIDEgMCAwIDEgMCAySDFhMSAxIDAgMCAxIDAtMnoiLz4KPC9zdmc+Cg==";
export { SvgList as ReactComponent };